import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { MCard } from "components/Shared";
import { Button } from "react-md";
import { setSelectedCustomerNumber } from "actions/customer";
import WebConfig from "middlewares/WebConfig";

interface CustomerNavigationCardProps {
  verticalDisplay: boolean;
  customerNumber: number; // Customer number to select when opening survey types
  // Redux
  setSelectedCustomerNumber: (customerNumber: string | number) => void;
  // Router
  history: any;
  token: string;
}

interface CustomerNavigationButton {
  title: string;
  onClick: () => void;
};

const CustomerNavigationCard = (props: CustomerNavigationCardProps) => {

  const navigateToSurveyTypes = () => {
    props.setSelectedCustomerNumber(props.customerNumber);
    props.history.push({
      pathname: "/customer/survey-types",
    });
  };

  const navigateToHubSite = (windowName: string, returnUrl: string) => {
    const url = `${WebConfig.hubRoot}/Account/LoginToken?returnUrl=${encodeURIComponent(returnUrl)}&${WebConfig.ssoTokenName}=${encodeURIComponent(props.token)}`
    window.open(url, windowName);
  };

  const navigateToCustomerFeatures = () => {
    // Route the user to the hub site with sso token to login
    const windowName = `CustomerFeaturesHub${props.customerNumber}`
    const returnUrl = `/Customers/Features?CustomerNumber=${props.customerNumber}`; // becomes the returnUrl
    navigateToHubSite(windowName, returnUrl);
  };

  const navigateToBillingDiscounts = () => {
    // Route the user to the hub site with sso token to login
    const windowName = `BillingDiscountsHub${props.customerNumber}`
    let returnUrl = `/Customers/BillingTimeServiceDiscounts?CustomerNumber=${props.customerNumber}`; // becomes the returnUrl
    navigateToHubSite(windowName, returnUrl);
  };

  const buttons: CustomerNavigationButton[] = [
    {
      title: "Open Survey Types",
      onClick: navigateToSurveyTypes
    },
    {
      title: "Open Features Hub",
      onClick: navigateToCustomerFeatures
    },
    {
      title: "Open Billing / Discount Rules",
      onClick: navigateToBillingDiscounts
    },
  ];

  const cellWidth = props.verticalDisplay ? 12 : 4;

  return (
    <MCard
      title={"Additional Information"}
      cellWidth={cellWidth}
      children={
        <div className="customer-navigation-card-button-container">
          {buttons.map((b, i) => (
            <>
              <Button
                Button
                primary
                raised
                onClick={b.onClick}
              >
                {b.title}
              </Button>
              {i < buttons.length - 1 ? <br /> : <></>}
            </>
          ))}
        </div>
      }
    />
  );
};

const mapStateToProps = state => ({
  token: state.user.profile.token
});

const mapDispatchToProps = dispatch => ({
  setSelectedCustomerNumber(customerNumber: string | number) {
    dispatch(setSelectedCustomerNumber(customerNumber));
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerNavigationCard));
